import { generatePath } from 'react-router-dom';

import router, { RouteItemType } from '~/core/router';
import { withSubModalsLayout } from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import { ChatByIdPath, getChatTitle } from '~/modules/chat/constants';
import LocaleRootRedirect from '~/projects/polyllm-chat/i18n/LocaleRootRedirect';

const Chat = lazyComponentLoader(() => import('~/modules/chat/views'));

const WrappedChat = withSubModalsLayout(Chat);

// Bare "/" → resolve locale and redirect to the localized chat index.
const ChatRootRoute: RouteItemType = {
  Component: LocaleRootRedirect,
  path: '/',
  getTitle: getChatTitle,
};

const ChatByIdRoute: RouteItemType = {
  Component: WrappedChat,
  path: ChatByIdPath,
  getTitle: getChatTitle,
};

// Register as unAuthorized so both anonymous and logged-in users see the chat.
// Routes are plain (no locale prefix); the active locale lives in the router
// `basename` (set from the URL), so a `/fr/...` URL matches these same routes.
router.addUnAuthorizedRoutes([ChatRootRoute, ChatByIdRoute]);

router.setDefaultPrivateRoutePath(
  generatePath(ChatByIdPath, { chatId: 'index' }),
);
